import { request } from '@/utils/request';

/**
 * 档口获取上传记录
 */
export function getUpList(data: API.GetUploadListParam) {
  return request({
    url: '/seller/ptUpGoods/getList',
    method: 'post',
    data,
  });
}
